<template>
    <div class="page-header">
        <van-nav-bar :title="$route.name" left-text="返回" left-arrow @click-left="$router.go(-1)">
            <van-icon name="column" slot="right" @click="$router.push({ path: '/bookshelf' })" />
            <van-icon name="wap-home-o" slot="right" @click="$router.push({ path: '/' })" />
        </van-nav-bar>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pagename: "搜索"
        };
    }
};
</script>

<style lang="less">
.page-header {
    .van-nav-bar {
        background: rgb(184, 51, 32);
        .van-nav-bar__left {
            left: 0;
            font-size: 14px;
            span.van-nav-bar__text {
                color: #ffffff;
                padding-left: 20px;
                // line-height: 26px;
            }
            &:active {
                background: transparent;
            }
        }
        .van-nav-bar__title {
            color: #ffffff;
            font-size: 16px;
            letter-spacing: 3px;
            span.van-nav-bar__text {
                color: #ffffff;
                padding-left: 20px;
                // line-height: 26px;
            }
            &:active {
                background: transparent;
            }
        }
        .van-icon {
            font-size: 1.5em;
            color: #ffffff;
            margin: 0 0 0 5px;
            .van-nav-bar__right {
            }
        }
    }
}
</style>
